import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WebProviderService } from '../web/web.provider.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomersProviderService {
  protected webProvider = inject(WebProviderService);
  protected readonly baseURL = environment.apiURL;

  async getIframeID(ringBuilderID: string): Promise<string | null> {
    try {
      return await this.webProvider.get<string>(`${this.baseURL}/api/customers/${ringBuilderID}/iframeid`, { responseType: 'text' });
    } catch (error) {
      if (error instanceof HttpErrorResponse && error.status === 404) {
        return null;
      }
      throw new Error('Failed to fetch iframe ID');
    }
  }
}
